import { __read, __spread } from "tslib";
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { DataTable, DataTableColumnProvider } from '../DataTable/DataTable';
import { RoutedEntityPage } from './RoutedEntityPage';
export var EntityListPage = function (_a) {
    var entityListColumns = _a.entityListColumns, titleProvider = _a.titleProvider, subTitleProvider = _a.subTitleProvider, iconProvider = _a.iconProvider, entityService = _a.entityService, entityStateProvider = _a.entityStateProvider, entityStateSelector = _a.entityStateSelector;
    var state = useSelector(entityStateSelector);
    var dispatch = useDispatch();
    var navigate = useNavigate();
    useMemo(function () {
        if (!state.isFetched && !state.isFetching) {
            dispatch(entityStateProvider.loadState());
        }
    }, [state, dispatch]);
    var navModelItem = {
        text: titleProvider({ pageName: 'list' }),
        subTitle: subTitleProvider({ pageName: 'list' }),
        icon: iconProvider({ pageName: 'list' }),
        url: './'
    };
    var navModel = {
        main: navModelItem,
        node: navModelItem
    };
    return (React.createElement(RoutedEntityPage, { model: navModel },
        React.createElement("div", null,
            React.createElement(DataTable, { onCreateClick: function () { return navigate('./new'); }, columnProvider: new DataTableColumnProvider({
                    columnDescriptions: __spread(entityListColumns),
                    deleteModalProps: {
                        onClose: function (result) { }
                    },
                    onEditClick: function (row) {
                        navigate("./item/" + row.itemId + "/edit");
                    },
                    onDeleteClick: function (row) {
                        if (row.itemId) {
                            entityService.delete(row.itemId).then(function () {
                                dispatch(entityStateProvider.loadState());
                            });
                        }
                    },
                    onViewClick: function (row) {
                        navigate("./item/" + row.itemId);
                    }
                }), entityState: state }))));
};
//# sourceMappingURL=EntityListPage.js.map